"use strict";
exports.__esModule = true;
exports.Form = void 0;
var Form = /** @class */ (function () {
    function Form(config) {
        this.config = config;
        this.form = config.form;
    }
    Form.prototype.setValidator = function (validator) {
        this.validator = validator;
    };
    Form.prototype.getValidator = function () {
        return this.validator;
    };
    Form.prototype.getElement = function () {
        return this.form;
    };
    return Form;
}());
exports.Form = Form;
